import * as React from 'react';

import styles from '../index.module.css';
import Footer from '../../Footer';
import NavBar, { View } from '../../../../../components/NavBar';
import { Button, Margin, Size, Width } from '../../../../../components/Button';

interface Props {
  value: string;
  updateFieldValue: (value: string) => void;
  saveFieldValue: (value: string) => void;
}

export class ReasonForVisitPage extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <NavBar view={View.Form} />
        <div className={styles.ReasonForVisitBorder}>
          <div className={styles.RFV}>
            <div className={styles.RFVBody}>
              <div className={styles.ReasonForVisitContainer}>
                <div className={styles.Label}>
                  Have you already seen a provider to receive medical care for
                  this issue?
                </div>
                <div className={styles.ButtonRow}>
                  <Button
                    size={Size.Medium}
                    width={Width.Full}
                    margin={Margin.None}
                  >
                    Yes
                  </Button>
                  <Button
                    size={Size.Medium}
                    width={Width.Full}
                    margin={Margin.None}
                  >
                    No
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.SchedulingSeparator} />
          <Footer />
        </div>
      </>
    );
  }
}

export default ReasonForVisitPage;
